const GlobalIcon = (props) => (
  <svg
    width={13}
    height={13}
    viewBox='0 0 13 13'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.50004 12.3229C3.28796 12.3229 0.677124 9.71208 0.677124 6.5C0.677124 3.28792 3.28796 0.677086 6.50004 0.677086C9.71212 0.677086 12.323 3.28792 12.323 6.5C12.323 9.71208 9.71212 12.3229 6.50004 12.3229ZM6.50004 1.48959C3.73754 1.48959 1.48962 3.7375 1.48962 6.5C1.48962 9.2625 3.73754 11.5104 6.50004 11.5104C9.26254 11.5104 11.5105 9.2625 11.5105 6.5C11.5105 3.7375 9.26254 1.48959 6.50004 1.48959Z'
      fill='#292D32'
    />
    <path
      d='M4.875 11.7812H4.33334C4.11125 11.7812 3.92709 11.5971 3.92709 11.375C3.92709 11.1529 4.10042 10.9742 4.3225 10.9688C3.47209 8.06542 3.47209 4.93458 4.3225 2.03125C4.10042 2.02583 3.92709 1.84708 3.92709 1.625C3.92709 1.40292 4.11125 1.21875 4.33334 1.21875H4.875C5.005 1.21875 5.12959 1.28375 5.20542 1.38667C5.28125 1.495 5.30292 1.63042 5.25959 1.755C4.24125 4.81542 4.24125 8.18458 5.25959 11.2504C5.30292 11.375 5.28125 11.5104 5.20542 11.6188C5.12959 11.7163 5.005 11.7812 4.875 11.7812Z'
      fill='#292D32'
    />
    <path
      d='M8.12505 11.7812C8.08172 11.7812 8.03839 11.7758 7.99505 11.7596C7.7838 11.6892 7.66464 11.4563 7.74047 11.245C8.7588 8.18458 8.7588 4.81542 7.74047 1.74958C7.67005 1.53833 7.7838 1.30542 7.99505 1.235C8.21172 1.16458 8.43922 1.27833 8.50964 1.48958C9.58755 4.71792 9.58755 8.27125 8.50964 11.4942C8.45547 11.6729 8.29297 11.7812 8.12505 11.7812Z'
      fill='#292D32'
    />
    <path
      d='M6.5 9.31667C4.98875 9.31667 3.48292 9.10542 2.03125 8.6775C2.02583 8.89417 1.84708 9.07292 1.625 9.07292C1.40292 9.07292 1.21875 8.88875 1.21875 8.66667V8.125C1.21875 7.995 1.28375 7.87042 1.38667 7.79458C1.495 7.71875 1.63042 7.69708 1.755 7.74042C4.81542 8.75875 8.19 8.75875 11.2504 7.74042C11.375 7.69708 11.5104 7.71875 11.6188 7.79458C11.7271 7.87042 11.7867 7.995 11.7867 8.125V8.66667C11.7867 8.88875 11.6025 9.07292 11.3804 9.07292C11.1583 9.07292 10.9796 8.89958 10.9742 8.6775C9.51708 9.10542 8.01125 9.31667 6.5 9.31667Z'
      fill='#292D32'
    />
    <path
      d='M11.375 5.28125C11.3317 5.28125 11.2884 5.27583 11.245 5.25958C8.18463 4.24125 4.81005 4.24125 1.74963 5.25958C1.53296 5.33 1.30546 5.21625 1.23505 5.005C1.17005 4.78833 1.2838 4.56083 1.49505 4.49041C4.72338 3.4125 8.27671 3.4125 11.4996 4.49041C11.7109 4.56083 11.83 4.79375 11.7542 5.005C11.7055 5.17291 11.543 5.28125 11.375 5.28125Z'
      fill='#292D32'
    />
  </svg>
);
export default GlobalIcon;
